module.exports = __webpack_public_path__ + "logo-black.7e5a377c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/logo-black.png
// module id = 2556
// module chunks = 0